import moment from 'moment';
import { Control, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Text, View } from 'react-native';
import { formStyles } from '../../styles/forms';
import { DatePickerSelector } from '../forms';

type AdjustCreationDateFieldProps = {
  control: Control<any>;
  setValue: UseFormSetValue<any>;
};

export const AdjustCreationDateField = ({
  control,
  setValue,
}: AdjustCreationDateFieldProps) => {
  const { t } = useTranslation();

  return (
    <>
      <View>
        <Text style={formStyles.formItemTitle}>
          {t('issue.adjustCreationDate.header')}
        </Text>
      </View>
      <DatePickerSelector
        name="adjustCreationDate"
        setValue={setValue}
        control={control}
        label=""
        placeholder={t('issue.dateFormat')}
        maxYears={10}
        minDate={moment().subtract(5, 'year').format('YYYY-MM-DD')}
      />
    </>
  );
};
